'use strict';

var jsxRuntime = require('react/jsx-runtime');

const SmallPaperPen = ()=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("rect", {
                x: "4",
                y: "2",
                width: "22",
                height: "28",
                rx: "4",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M10 19H14",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M10 9H20",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M10 14H20",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M27.1375 12.5552C28.0084 11.6843 29.4204 11.6843 30.2913 12.5552C31.1622 13.4261 31.1622 14.8381 30.2913 15.709L22.4862 23.514L18.5771 24.2693L19.3324 20.3602L27.1375 12.5552Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinejoin: "round"
            })
        ]
    });
};
const MediumPaperPen = ()=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("rect", {
                x: "6",
                y: "4",
                width: "26",
                height: "32",
                rx: "4",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M13 22L17 22",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M13 12H25",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M13 17H25",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M33.0208 15.1213C34.1923 13.9497 36.0918 13.9497 37.2634 15.1213C38.435 16.2929 38.435 18.1924 37.2634 19.364L28.0582 28.5691L23.1213 29.2635L23.8156 24.3265L33.0208 15.1213Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinejoin: "round"
            })
        ]
    });
};
const PaperPen = ({ size })=>{
    if (size === 'small') return jsxRuntime.jsx(SmallPaperPen, {});
    return jsxRuntime.jsx(MediumPaperPen, {});
};

module.exports = PaperPen;
